import { render } from "./OrdenesFacturacionView.vue?vue&type=template&id=5f3dd11a"
import script from "./OrdenesFacturacionView.vue?vue&type=script&lang=js"
export * from "./OrdenesFacturacionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__